<template>
  <v-container fluid>
    <v-layout column>
      <v-flex d-inline-flex align-center class="section-1 general-bg" py-2 px-3>
        <h2 style="max-width:100px;">Alarmas</h2>
        <!-- :items="adminRole === 500 ? items : itemsAlt" -->
        <!-- :items="adminRole !== null || role[0] === 23 || role[0] === 1 ? items : itemsAlt" -->
        <!-- :items="items" -->
        <!-- :items="adminRole !== null
          ? (adminRole === 500 ? itemsFullAccess : items)
          : itemsAlt
        " -->
        <v-autocomplete
          label="Elegir tipo de alarma"
          v-model="alert"
          :items="adminRole !== null ? itemsFullAccess : itemsAlt"
          item-text="text"
          item-value="value"
          return-object
          autocomplete
        ></v-autocomplete>
      </v-flex>

      <v-flex v-if="alert" ma-0 pt-3>
        <!-- MOVEMENT ALERTS -->
        <movement-alerts v-if="alert.value === 0" />

        <!-- SPEED ALERTS -->
        <speed-alerts v-if="alert.value === 1" />

        <!-- FAILED MISSIONS ALERTS -->
        <mission-alerts v-if="alert.value === 2" />

        <!-- OPERATIVE VEHICLES WITHOUT REPORT 72 HRS -->
        <unreported-events-alerts v-if="alert.value === 3" />

        <!-- PARKING ALERTS -->
        <parking-alerts v-if="alert.value === 4" />

        <!-- GEOFENCE IN ALERT -->
        <geofence-in-alerts v-if="alert.value === 5" />

        <!-- VEHICLES WITHOUT EVENTS +3H -->
        <vehicles-without-events-3h-alerts v-if="alert.value === 6" />

        <!-- SOS REPORTS -->
        <s-o-s-reports v-if="alert.value === 7" />
      </v-flex>

      <!-- BIG ICON LOADING -->
      <v-flex v-else class="text-xs-center" pt-5>
        <v-avatar
          size="400px"
          color="grey darken-4">
          <v-icon size="280px" color="grey darken-3">notifications</v-icon>
        </v-avatar>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
// import * as types from '../store/mutations-types'
import MovementAlerts from './MovementAlerts'
import SpeedAlerts from './SpeedAlerts'
import MissionAlerts from './MissionAlerts'
import UnreportedEventsAlerts from './UnreportedEventsAlerts'
import ParkingAlerts from './ParkingAlerts'
import GeofenceInAlerts from './GeofenceInAlerts'
import VehiclesWithoutEvents3hAlerts from './VehiclesWithoutEvents3hAlerts.vue'
import SOSReports from './SOSReports.vue'

export default {
  name: 'base-alerts',
  components: {
    UnreportedEventsAlerts,
    MovementAlerts,
    SpeedAlerts,
    MissionAlerts,
    ParkingAlerts,
    GeofenceInAlerts,
    VehiclesWithoutEvents3hAlerts,
    SOSReports
  },
  data() {
    return {
      alert: {},
      // items: [
      //   { value: 0, text: 'En Movimiento sin Autorización' },
      //   { value: 1, text: 'Excesos de Velocidad' },
      //   { value: 2, text: 'Salidas de Geocerca' },
      //   { value: 3, text: 'Vehículos Operativos sin Reporte 72 Horas' }
      // ],
      itemsFullAccess: [
        { value: 0, text: 'En Movimiento sin Autorización' },
        { value: 1, text: 'Excesos de Velocidad' },
        { value: 2, text: 'Salidas de Geocerca' },
        { value: 5, text: 'Ingreso a Geocerca' },
        { value: 4, text: 'Estacionarias (Minuta de Servicio)' },
        { value: 3, text: 'Vehículos Operativos sin Reporte 72 Horas' },
        { value: 6, text: 'Vehículos instalados sin eventos +3h' },
        { value: 7, text: 'SOS' }
      ],
      itemsAlt: [
        { value: 0, text: 'En Movimiento sin Autorización' },
        { value: 1, text: 'Excesos de Velocidad' },
        { value: 2, text: 'Salidas de Geocerca' },
        { value: 5, text: 'Ingreso a Geocerca' },
        { value: 4, text: 'Estacionarias (Minuta de Servicio)' },
        { value: 7, text: 'SOS' }
      ]
    }
  },
  watch: {
    role(newValue, oldValue) {
      // console.log('WATCH ROLE IN: ', newValue, oldValue)
    },
    adminRole(newValue, oldValue) {
      // console.log('WATCH ADMIN ROLE IN: ', newValue, oldValue)
    }
  },
  computed: {
    ...mapGetters({
      role: 'auth/role',
      adminRole: 'auth/adminRole'
    })
  },
  mounted() {
    // console.log('MOUNTED ALERTS: ', this.role, this.adminRole)
  }
}
</script>

<style lang="stylus" scoped>
.section-1
  width 470px

.general-bg
  background-color #424242
  border-radius 3px

</style>



// WEBPACK FOOTER //
// src/components/BaseAlerts.vue